import { UzButton, UzDialog, UzInput, UzTextarea } from '@utazzo/ui';
import React, { useState } from 'react';

import { localTodayISO } from '@/lib/date-format';

export interface ChallanFormValues {
  challanNo: string;
  /** YYYY-MM-DD from the date input (local calendar date). */
  challanDate: string;
  note: string;
}

interface TcsChallanFormDialogProps {
  open: boolean;
  invoiceCount: number;
  pending?: boolean;
  onConfirm: (values: ChallanFormValues) => void;
  onCancel: () => void;
}

/** Collects the optional challan no, deposit date and note when creating a combined challan. */
export const TcsChallanFormDialog = ({
  open,
  invoiceCount,
  pending,
  onConfirm,
  onCancel,
}: TcsChallanFormDialogProps): React.JSX.Element => {
  const [challanNo, setChallanNo] = useState('');
  const [challanDate, setChallanDate] = useState(localTodayISO());
  const [note, setNote] = useState('');

  return (
    <UzDialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onCancel();
      }}
      title="Create challan"
      description={`One combined challan covering ${invoiceCount} selected invoice${invoiceCount === 1 ? '' : 's'}. You can add the challan number later.`}
      size="md"
      footer={
        <div className="flex justify-end gap-2">
          <UzButton variant="ghost" onClick={onCancel}>
            Cancel
          </UzButton>
          <UzButton
            loading={pending}
            onClick={() =>
              onConfirm({ challanNo: challanNo.trim(), challanDate, note: note.trim() })
            }
          >
            Create challan
          </UzButton>
        </div>
      }
    >
      <div className="space-y-3">
        <UzInput
          label="Challan no."
          value={challanNo}
          onChange={(e) => setChallanNo(e.target.value)}
          placeholder="Optional"
        />
        <div>
          <label
            htmlFor="tcs-challan-date"
            className="mb-1 block text-sm font-medium text-zinc-700"
          >
            Challan date
          </label>
          <input
            id="tcs-challan-date"
            type="date"
            value={challanDate}
            onChange={(e) => setChallanDate(e.target.value)}
            className="border-input focus-visible:ring-ring flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:ring-1 focus-visible:outline-none"
          />
        </div>
        <UzTextarea
          label="Note"
          value={note}
          maxLength={1000}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Optional"
        />
      </div>
    </UzDialog>
  );
};
